// window.open()はクリックのユーザー操作に対して同期的に呼ばないと、ブラウザ（特に
// Android Chrome）にポップアップとしてブロックされる。画像ダウンロード等の非同期処理を
// 挟んでからwindow.open()すると、件数が多く数秒以上かかる場合にユーザー操作からの
// 経過時間とみなされてブロックされることがある。この関数を各処理の最初（最初のawaitより
// 前）で呼び、空のタブだけ先に開いておくことでユーザー操作に対する同期性を保つ。
// 開いたタブへは、コンテンツ準備後にopenTabWithContentで書き込む。
//
// AdminPanel.js・SuperAdminPanel.js・RegressionTestTab.js（AdminPanel.jsからimportされる
// ため循環参照を避ける必要がある）の3箇所から共用するため、独立したモジュールに切り出す
export function openBlankTab() {
  const w = window.open('', '_blank');
  if (!w) { alert('ポップアップがブロックされました。ブラウザの設定を確認してください。'); return null; }
  w.document.write('<!DOCTYPE html><html lang="ja"><head><meta charset="UTF-8"><title>生成中...</title></head><body style="font-family:sans-serif;padding:20px;color:#64748b">PDFを生成しています。しばらくお待ちください…</body></html>');
  return w;
}

// openBlankTabで先に開いておいたタブに、準備できたHTMLを書き込む
export function openTabWithContent(w, html) {
  w.document.open();
  w.document.write(html);
  w.document.close();
}
